import axios from 'axios'
import { takeEvery, call, put, takeLatest } from 'redux-saga/effects'
import {
  ADD_WHITELIST_ITEM,
  POST_AND_UPDATE,
  SET_CUSTOM_FILTER,
} from './requests/products/product.actions'
import { requestActions } from './requests'
import { getAuth } from 'firebase/auth'
import app from '../firebase/initialize'
import { GET_USER_BY_UID, SIGN_UP } from './requests/auth/auth.actions'
import { SET_USER } from './misc/types'
import { Filter } from './requests/products/product.types'

const auth = getAuth(app)

export default function* IndexSaga() {
  yield takeLatest(GET_USER_BY_UID, userHandler)
  yield takeEvery(POST_AND_UPDATE, postAndUpdate)
  yield takeEvery(ADD_WHITELIST_ITEM, addAndGetWhitelist)
  yield takeEvery(SET_CUSTOM_FILTER, setAndGetCustomFilter)
  yield takeEvery(SIGN_UP, signUpAndSendVerification)
}

function* setAndGetCustomFilter(action: any) {
  yield call(setCustomFilter, action)
  yield action.dispatch(requestActions.products.getCustomFilters(action.uid))
}
function* signUpAndSendVerification(action: any) {
  yield call(signUp, action.data)
  yield action.dispatch(requestActions.auth.sendEmailVerification({ email: action.data.email }))
}

function* addAndGetWhitelist(action: any) {
  yield call(addToWhiteList, action)
  yield action.dispatch(requestActions.auth.getWhitelist(action.uid))
}

function* postAndUpdate(action: any) {
  const data = yield call(postToApi, action.data)

  if (data.data.error === 'Filen finns redan ERROR') {
    action.setDuplicatedFiles(prev => [...prev, data.data.fileName])
    action.setFileIsDuplicate(true)
  }

  yield action.dispatch(requestActions.products.fetchAllProductDataByUser(action.uid))

  yield action.setNumPendingCards(currentValue =>
    currentValue.length > 1 ? currentValue.slice(1) : [],
  )
}

function* userHandler(action: any) {
  const response = yield call(getUserById, action.request.url)
  const { data } = response
  const userAction = { type: SET_USER, data }
  yield put(userAction)
}

async function signUp(formData) {
  return axios.post(`${process.env.REACT_APP_API_URL}/users/signup`, formData, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-app-version': '1.0.0',
    },
  })
}

async function getUserById(userUrl: string) {
  return axios.get(`${process.env.REACT_APP_API_URL}${userUrl}`)
}

async function postToApi(formData) {
  const token = await auth.currentUser?.getIdToken()

  return await axios.post(`${process.env.REACT_APP_API_URL}/products/receivePDF`, formData, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-app-version': '1.0.0',
      authorization: token ? `Bearer ${token}` : '',
    },
  })
}

async function addToWhiteList(action) {
  const token = await auth.currentUser?.getIdToken()
  return await axios.post(
    `${process.env.REACT_APP_API_URL}/users/addwhitelistitem/userid/${action.uid}`,
    { data: action.data },

    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-app-version': '1.0.0',
        authorization: token ? `Bearer ${token}` : '',
      },
    },
  )
}

async function setCustomFilter(action: Filter & { uid: string }) {
  const token = await auth.currentUser?.getIdToken()

  return await axios.post(
    `${process.env.REACT_APP_API_URL}/users/customfilter/userid/${
      action.uid
    }/start/${action.start.toString()}/end/${action.end.toString()}/caption/${action.caption}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-app-version': '1.0.0',
        authorization: token ? `Bearer ${token}` : '',
      },
    },
  )
}
